import { ENV } from '@/environment/client';

/** Waits up to three seconds for Ledger EVM discovery; skips SSR and unconfigured clients. */
export function waitForLedgerProvider(): Promise<void> {
  if (typeof window === 'undefined' || !ENV.NEXT_PUBLIC_LEDGER_API_KEY) {
    return Promise.resolve();
  }

  // Promise.withResolvers is unavailable in supported Chrome 111 and Safari 16.4.
  return new Promise((resolve) => {
    const finish = () => {
      window.clearTimeout(timeout);
      window.removeEventListener('eip6963:announceProvider', onAnnouncement);
      resolve();
    };
    const onAnnouncement = (event: Event) => {
      const { detail } = event as CustomEvent<{ info?: { rdns?: string } }>;
      if (detail?.info?.rdns === 'com.ledger.wallet.provider') finish();
    };
    const timeout = window.setTimeout(finish, 3_000);

    window.addEventListener('eip6963:announceProvider', onAnnouncement);
    // An already-initialized provider must announce again for this new listener.
    window.dispatchEvent(new Event('eip6963:requestProvider'));
  });
}
